module.exports = __webpack_public_path__ + "static/media/cityinfoLogotrans.2c3fb1fa.png";